import { CustomerAddressModel } from '@simploshop-models/customer-address.model'

interface Attributes {
    [CartCustomerAddressModel.ATTR_CAN_BE_USED_AS_BILLING]: boolean
    [CartCustomerAddressModel.ATTR_CAN_BE_USED_AS_SHIPPING]: boolean
}

export class CartCustomerAddressModel extends CustomerAddressModel<Attributes> {
    static override key = 'CartCustomerAddressModel'

    static readonly ATTR_CAN_BE_USED_AS_BILLING = 'can_be_used_as_billing'
    static readonly ATTR_CAN_BE_USED_AS_SHIPPING = 'can_be_used_as_shipping'

    get canBeUsedAsBilling() {
        return this._getAttribute(CartCustomerAddressModel.ATTR_CAN_BE_USED_AS_BILLING)
    }

    get canBeUsedAsShipping() {
        return this._getAttribute(CartCustomerAddressModel.ATTR_CAN_BE_USED_AS_SHIPPING)
    }
}
